"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _react = _interopRequireWildcard(require("react")),
    _reactApollo = require("react-apollo"),
    _AuthenticationWrapper = require("../../AuthenticationWrapper"),
    _RequestAccess = _interopRequireDefault(require("./RequestAccess")),
    _utils = require("../utils");

function _createSuper(Derived) {
  return function () {
    var result,
        Super = (0, _getPrototypeOf2["default"])(Derived);

    if (_isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else result = Super.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}

var RequestProvider = function (_Component) {
  function RequestProvider() {
    var _this;

    return (0, _classCallCheck2["default"])(this, RequestProvider), _this = _super.call(this), _this.promptRequestAccess = function (_ref) {
      var resourceOwnerId = _ref.resourceOwnerId;

      _this.setState({
        resourceOwnerId: resourceOwnerId
      });
    }, _this.state = {
      resourceOwnerId: void 0
    }, _this;
  }

  (0, _inherits2["default"])(RequestProvider, _Component);

  var _super = _createSuper(RequestProvider);

  return (0, _createClass2["default"])(RequestProvider, [{
    key: "render",
    value: function render() {
      var _this2 = this,
          _this$props = this.props,
          children = _this$props.children,
          requests = _this$props.requests,
          resourceOwnerId = this.state.resourceOwnerId;

      return _react["default"].createElement(_AuthenticationWrapper.AuthenticationConsumer, null, function (_ref2) {
        var promptWelcomeGuestLogin = _ref2.promptWelcomeGuestLogin;
        return _react["default"].createElement(_reactApollo.ApolloConsumer, null, function (client) {
          return resourceOwnerId ? _react["default"].createElement(_RequestAccess["default"], {
            apiClient: client,
            ownerId: resourceOwnerId
          }) : children((0, _utils.mapRequests)(client, requests, promptWelcomeGuestLogin, _this2.promptRequestAccess));
        });
      });
    }
  }]), RequestProvider;
}(_react.Component);

exports["default"] = RequestProvider;